import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import { actions } from './redux/actions';
import '../Widgets.scss';
import Strings from '../../../../Strings';

function TotalKits(props) {
  const { isLoading, totalKits, orgIds, refreshTimestamp, getData, onClick } = props;
  
  React.useEffect(() => {
    getData((orgIds && orgIds.length > 0) ? orgIds : undefined);
  }, [orgIds, refreshTimestamp]);

  return isLoading ? null : (
    <div className="boxWithVl-box">
      <div className="boxWithVl-valueBox black">{totalKits}</div>
      <div onClick={() => onClick('/devices/Kit')} className="boxWithVl-labelBox clickable">
        {Strings.totalKits}
      </div>
    </div>
  );
}

TotalKits.widgetId = 'TotalKitsWidget';

TotalKits.propTypes = {
  getData: PropTypes.func,
  totalKits: PropTypes.any,
  orgIds: PropTypes.array,
  refreshTimestamp: PropTypes.number,
  isLoading: PropTypes.any,
  onClick: PropTypes.func,
};

const mapStateToProps = state => {
  const { widgetTotalKitsReducer } = state.dashboardWidgets;
  return {
    totalKits: widgetTotalKitsReducer && widgetTotalKitsReducer?.totalKits,
    isLoading: widgetTotalKitsReducer && widgetTotalKitsReducer?.isLoading,
    orgIds: state.entities?.orgFilter?.orgIds,
  };
};

const mapDispatchToProps = dispatch => ({
  getData: orgFilter => dispatch(actions.getTotalKits(orgFilter)),
  onClick: path => dispatch(push(path)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TotalKits);
